import axios from "axios";
import { get } from "lodash";
import { logout } from "../slice/auth";

const endpoint = `${process.env.REACT_APP_API_URL}`;

export const configAxios = (store) => {
  axios.defaults.baseURL = endpoint;

  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      // Nest returns the HTTP status (and `statusCode` in the body); older
      // responses used `code`. The login call is skipped so a failed
      // sign-in shows its error instead of resetting the form.
      const status =
        get(error, "response.status") ??
        get(error, "response.data.statusCode") ??
        get(error, "response.data.code");
      const isLoginRequest = get(error, "config.url", "").includes(
        "/auth/login"
      );

      if (status === 401 && !isLoginRequest) {
        // Layout redirects to /login once the token is cleared.
        store.dispatch(logout());
      }

      return Promise.reject(error);
    }
  );
};
